module.exports = __webpack_public_path__ + "img/PMTutorial.78ca968d.png";